var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-container" }, [
    !_vm.loading
      ? _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "mb-3" }, [
            _c(
              "div",
              { staticClass: "has-text-weight-semibold is-size-6 mb-5" },
              [_vm._v(" Add Geofence ")]
            ),
            _c(
              "div",
              {
                staticClass:
                  "has-text-danger has-text-weight-semibold is-size-7 mb-2",
              },
              [_vm._v(" " + _vm._s(_vm.msg) + " ")]
            ),
            _c("div", { staticClass: "field mb-2" }, [
              _c("label", { staticClass: "label is-size-7 mb-1" }, [
                _vm._v("Information"),
              ]),
              _c("div", { staticClass: "content-box p-2" }, [
                _c(
                  "div",
                  { staticClass: "is-size-7 has-text-weight-semibold mb-2" },
                  [_vm._v(" Zone: " + _vm._s(_vm.shape?.zone || "") + " ")]
                ),
                _c(
                  "div",
                  { staticClass: "is-size-7 has-text-weight-semibold mb-2" },
                  [
                    _vm._v(
                      " Distribution Zone: " +
                        _vm._s(_vm.shape?.hub?.DistributionZoneName || "") +
                        " "
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
          _c("div", { staticClass: "buttons-container" }, [
            _c("div", { staticClass: "buttons is-centered" }, [
              _c(
                "button",
                {
                  staticClass: "button is-small",
                  on: {
                    click: function ($event) {
                      return _vm.cancelEdit()
                    },
                  },
                },
                [_vm._v("Cancel")]
              ),
              _vm.editable
                ? _c(
                    "button",
                    {
                      staticClass: "button is-small is-success",
                      on: { click: _vm.editFirestore },
                    },
                    [_vm._v("Save")]
                  )
                : _vm._e(),
            ]),
          ]),
        ])
      : _c("div", { staticClass: "loader-container" }, [_c("PulseLoader")], 1),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }